export const containerClassName = (theme = {})=>{
    return theme['galleryPlugin'];
};
